module.exports = __webpack_public_path__ + "img/checkPequeño.a60a9a30.svg";